const LogoExists = (insurerId: string) => {
    try {
        require(`../../assets/ourInsurers/${insurerId.toLowerCase()}.png`);
        return true;
    } catch (err) {
        return false;
    }
};

const SchemeLogoExists = (schemeName: string) => {
    try {
        require(`../../assets/ourInsurers/schemeLogos/${schemeName}.png`);
        return true;
    } catch (err) {
        return false;
    }
};

export const GetLogo = (schemeName: string, insurerId: string, insurerName: string, showFallbackInsurerName: boolean) => {
    return (
        <>
            {SchemeLogoExists(schemeName) ?
                <img className="quote-logo" src={require(`../../assets/ourInsurers/schemeLogos/${schemeName}.png`)} />
                : LogoExists(insurerId.toLowerCase()) &&
                <img className="quote-logo" src={require(`../../assets/ourInsurers/${insurerId.toLowerCase()}.png`)}
                    alt={(`${insurerName.toLowerCase()}-logo`)} />}

            {(showFallbackInsurerName && !LogoExists(insurerId.toLowerCase()) && !SchemeLogoExists(schemeName)) &&
                insurerName}
        </>
    );
}